module.exports = __webpack_public_path__ + "static/media/slide_3.c81d9705.jpg";